
// src/components/BackButton.jsx

import { useNavigate } from 'react-router-dom';

export default function BackButton({ label = "Back" }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className="ob-btn ob-btn-ghost ob-btn-sm ob-backbtn"
      aria-label="Go back"
    >
      {/* The arrow slides on hover — the affordance that says "this goes
          backwards", not just "this is a button". */}
      <svg
        className="w-[14px] h-[14px] ob-backbtn-arrow"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.9}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
      {label}
    </button>
  );
}
